/**
 * @fileoverview gRPC-Web generated client stub for activity
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.35.1
// source: activity.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var user_pb = require('./user_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.activity = require('./activity_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.activity.ActivitatorClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.activity.ActivitatorPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.Activity,
 *   !proto.activity.Activity>}
 */
const methodDescriptor_Activitator_InsertActivity = new grpc.web.MethodDescriptor(
  '/activity.Activitator/InsertActivity',
  grpc.web.MethodType.UNARY,
  proto.activity.Activity,
  proto.activity.Activity,
  /**
   * @param {!proto.activity.Activity} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.Activity.deserializeBinary
);


/**
 * @param {!proto.activity.Activity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.Activity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.Activity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.insertActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/InsertActivity',
      request,
      metadata || {},
      methodDescriptor_Activitator_InsertActivity,
      callback);
};


/**
 * @param {!proto.activity.Activity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.Activity>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.insertActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/InsertActivity',
      request,
      metadata || {},
      methodDescriptor_Activitator_InsertActivity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.Activity,
 *   !proto.activity.Activity>}
 */
const methodDescriptor_Activitator_UpdateActivity = new grpc.web.MethodDescriptor(
  '/activity.Activitator/UpdateActivity',
  grpc.web.MethodType.UNARY,
  proto.activity.Activity,
  proto.activity.Activity,
  /**
   * @param {!proto.activity.Activity} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.Activity.deserializeBinary
);


/**
 * @param {!proto.activity.Activity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.Activity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.Activity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.updateActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/UpdateActivity',
      request,
      metadata || {},
      methodDescriptor_Activitator_UpdateActivity,
      callback);
};


/**
 * @param {!proto.activity.Activity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.Activity>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.updateActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/UpdateActivity',
      request,
      metadata || {},
      methodDescriptor_Activitator_UpdateActivity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.Activity,
 *   !proto.activity.Activity>}
 */
const methodDescriptor_Activitator_DeleteActivity = new grpc.web.MethodDescriptor(
  '/activity.Activitator/DeleteActivity',
  grpc.web.MethodType.UNARY,
  proto.activity.Activity,
  proto.activity.Activity,
  /**
   * @param {!proto.activity.Activity} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.Activity.deserializeBinary
);


/**
 * @param {!proto.activity.Activity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.Activity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.Activity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.deleteActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/DeleteActivity',
      request,
      metadata || {},
      methodDescriptor_Activitator_DeleteActivity,
      callback);
};


/**
 * @param {!proto.activity.Activity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.Activity>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.deleteActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/DeleteActivity',
      request,
      metadata || {},
      methodDescriptor_Activitator_DeleteActivity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.activity.Activities>}
 */
const methodDescriptor_Activitator_GetActivities = new grpc.web.MethodDescriptor(
  '/activity.Activitator/GetActivities',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.activity.Activities,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.Activities.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.Activities)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.Activities>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.getActivities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/GetActivities',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetActivities,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.Activities>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.getActivities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/GetActivities',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetActivities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.activity.Sporttypes>}
 */
const methodDescriptor_Activitator_GetSporttype = new grpc.web.MethodDescriptor(
  '/activity.Activitator/GetSporttype',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.activity.Sporttypes,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.Sporttypes.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.Sporttypes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.Sporttypes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.getSporttype =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/GetSporttype',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetSporttype,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.Sporttypes>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.getSporttype =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/GetSporttype',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetSporttype);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.activity.Bodyparts>}
 */
const methodDescriptor_Activitator_GetBodyParts = new grpc.web.MethodDescriptor(
  '/activity.Activitator/GetBodyParts',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.activity.Bodyparts,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.Bodyparts.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.Bodyparts)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.Bodyparts>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.getBodyParts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/GetBodyParts',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetBodyParts,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.Bodyparts>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.getBodyParts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/GetBodyParts',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetBodyParts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.ActivityTemplate,
 *   !proto.activity.ActivityTemplate>}
 */
const methodDescriptor_Activitator_InsertActivities = new grpc.web.MethodDescriptor(
  '/activity.Activitator/InsertActivities',
  grpc.web.MethodType.UNARY,
  proto.activity.ActivityTemplate,
  proto.activity.ActivityTemplate,
  /**
   * @param {!proto.activity.ActivityTemplate} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityTemplate.deserializeBinary
);


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.insertActivities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/InsertActivities',
      request,
      metadata || {},
      methodDescriptor_Activitator_InsertActivities,
      callback);
};


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityTemplate>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.insertActivities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/InsertActivities',
      request,
      metadata || {},
      methodDescriptor_Activitator_InsertActivities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.activity.ActivityTemplates>}
 */
const methodDescriptor_Activitator_GetActivityTemplates = new grpc.web.MethodDescriptor(
  '/activity.Activitator/GetActivityTemplates',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.activity.ActivityTemplates,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityTemplates.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityTemplates)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityTemplates>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.getActivityTemplates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/GetActivityTemplates',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetActivityTemplates,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityTemplates>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.getActivityTemplates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/GetActivityTemplates',
      request,
      metadata || {},
      methodDescriptor_Activitator_GetActivityTemplates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.ActivityTemplate,
 *   !proto.activity.ActivityTemplate>}
 */
const methodDescriptor_Activitator_InsertActivityTemplate = new grpc.web.MethodDescriptor(
  '/activity.Activitator/InsertActivityTemplate',
  grpc.web.MethodType.UNARY,
  proto.activity.ActivityTemplate,
  proto.activity.ActivityTemplate,
  /**
   * @param {!proto.activity.ActivityTemplate} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityTemplate.deserializeBinary
);


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.insertActivityTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/InsertActivityTemplate',
      request,
      metadata || {},
      methodDescriptor_Activitator_InsertActivityTemplate,
      callback);
};


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityTemplate>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.insertActivityTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/InsertActivityTemplate',
      request,
      metadata || {},
      methodDescriptor_Activitator_InsertActivityTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.ActivityTemplate,
 *   !proto.activity.ActivityTemplate>}
 */
const methodDescriptor_Activitator_UpdateActivityTemplate = new grpc.web.MethodDescriptor(
  '/activity.Activitator/UpdateActivityTemplate',
  grpc.web.MethodType.UNARY,
  proto.activity.ActivityTemplate,
  proto.activity.ActivityTemplate,
  /**
   * @param {!proto.activity.ActivityTemplate} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityTemplate.deserializeBinary
);


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.updateActivityTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/UpdateActivityTemplate',
      request,
      metadata || {},
      methodDescriptor_Activitator_UpdateActivityTemplate,
      callback);
};


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityTemplate>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.updateActivityTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/UpdateActivityTemplate',
      request,
      metadata || {},
      methodDescriptor_Activitator_UpdateActivityTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.ActivityTemplate,
 *   !proto.activity.ActivityTemplate>}
 */
const methodDescriptor_Activitator_DeleteActivityTemplate = new grpc.web.MethodDescriptor(
  '/activity.Activitator/DeleteActivityTemplate',
  grpc.web.MethodType.UNARY,
  proto.activity.ActivityTemplate,
  proto.activity.ActivityTemplate,
  /**
   * @param {!proto.activity.ActivityTemplate} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityTemplate.deserializeBinary
);


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityTemplate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityTemplate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivitatorClient.prototype.deleteActivityTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Activitator/DeleteActivityTemplate',
      request,
      metadata || {},
      methodDescriptor_Activitator_DeleteActivityTemplate,
      callback);
};


/**
 * @param {!proto.activity.ActivityTemplate} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityTemplate>}
 *     Promise that resolves to the response
 */
proto.activity.ActivitatorPromiseClient.prototype.deleteActivityTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Activitator/DeleteActivityTemplate',
      request,
      metadata || {},
      methodDescriptor_Activitator_DeleteActivityTemplate);
};


module.exports = proto.activity;

